<template>
  <q-pull-to-refresh @refresh="refresh">
    <q-card flat>
      <q-card-section class="no-padding">
        <q-banner class="bg-blue text-white" inline-actions>
          <span>لیست تراکنش های اخیر حساب</span> <span v-if="selectedAccount"
                                                       class="text-bold"> {{ selectedAccount.accountNumber }} </span>
          <template v-slot:action>
            <q-chip color="green" clickable @click="loadbalance" text-color="white" icon-right="attach_money">
              <span v-if="!$q.screen.lt.md">موجودی حساب</span> <span
                class="q-ml-xs text-bold">{{ accountBalance.toLocaleString() }}</span>
              <q-tooltip v-if="!$q.screen.lt.md">
                موجودی حساب
              </q-tooltip>
            </q-chip>
            <q-btn v-if="isDialog" flat round icon="close" v-close-popup/>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section class="no-padding" v-if="!selectedAccountNumber">
        <q-select v-model="selectedAccount"
                  :options="accountNumbers"
                  option-label="name"
                  option-value="accountNumber"
                  filled
                  :class="selectedRow?'q-mb-sm':''"
                  label="انتخاب حساب">
          <template v-slot:after
                    v-if="selectedAccount &&
                    $store.state.roles.some(v=>['admin','can_transfer_money'].includes(v))">
            <q-btn icon="account_balance_wallet" v-if="selectedAccount.accountNumber!== '0303647823007'" flat
                   color="indigo"
                   round
                   @click="openEmptyAccountDialog">
              <q-tooltip>
                انتقال وجه
              </q-tooltip>
            </q-btn>
            <q-btn icon="payments" flat
                   color="indigo"
                   round
                   v-if="$store.state.roles.some(v=>['admin','can_see_main_account_transactions'].includes(v))"
                   @click="loadTransactionsData">
              <q-tooltip>
                نمایش گردش حساب
              </q-tooltip>
            </q-btn>
          </template>
        </q-select>
      </q-card-section>
      <q-card-section class="no-padding">
        <q-table
            selection="single"
            row-key="CS_ID"
            wrap-cells
            bordered
            hide-no-data
            :hide-header="$q.screen.lt.md"
            flat
            :rows-per-page-options=[100]
            :data="transactions">
          <template v-slot:header>
            <q-tr class="text-center text-bold">
              <td>شناسه مشتری</td>
              <td>نام</td>
              <td>نام خانوادگی</td>
              <td>شماره کارت/شبا</td>
              <td>مبلغ واریزی</td>
              <td>مبلغ برداشتی</td>
              <td>تاریخ تراکنش</td>
            </q-tr>
            <q-tr class="text-center text-bold text-green">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <q-chip icon="attach_money"
                        color="green"
                        class="text-subtitle1"
                        text-color="white"
                        :label="lodash.sumBy(transactions, item=> parseInt(item.transactionAmountCredit)).toLocaleString()"/>
              </td>
              <td>
                <q-chip icon="attach_money"
                        color="red-10"
                        class="text-subtitle1"
                        text-color="white"
                        :label="lodash.sumBy(transactions, item=> parseInt(item.transactionAmountDebit)).toLocaleString()"/>
              </td>
              <td></td>
            </q-tr>
          </template>
          <template v-slot:top v-if="$q.screen.lt.md">
            <div class="row full-width">
              <div class="col">
                <q-card flat>
                  <q-card-section class="text-center no-padding">
                    <q-chip icon-right="attach_money" square color="green" text-color="white" size="lg"
                            :label="lodash.sumBy(transactions, item=> parseInt(item.transactionAmountCredit)).toLocaleString()">
                      <q-tooltip>
                        جمع کل واریزی
                      </q-tooltip>
                    </q-chip>
                    <q-chip icon-right="attach_money" square color="red-10" text-color="white" size="lg"
                            :label="lodash.sumBy(transactions, item=> parseInt(item.transactionAmountDebit)).toLocaleString()">
                      <q-tooltip>
                        جمع کل برداشتی
                      </q-tooltip>
                    </q-chip>
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </template>
          <template v-slot:body="props">
            <q-tr :props="props" class="text-center" v-if="!$q.screen.lt.md">
              <td>
                <q-chip square color="red"
                        text-color="white"
                        icon="person"
                        :label="props.row.Cs_Code"
                        v-if="props.row.Cs_Code"
                        @click="loadCustomer(props.row)"
                        clickable/>
                <q-btn v-if="!props.row.Cs_Code && props.row.transactionDescription !=='008'" label="انتخاب مشتری" flat
                       color="indigo"
                       @click="selectedBestCustomer(props.row)"/>
              </td>
              <td>
                {{ props.row.Cs_FirName }}
              </td>
              <td>
                {{ props.row.Cs_FamName }}
              </td>
              <td class="text-bold text-indigo">
                <q-card flat class="bg-transparent">
                  <q-card-section class="no-padding">
                    <q-btn color="brown"
                           square
                           flat
                           :disable="parseInt(props.row.transactionAmountDebit) > 0"
                           @click="getAccountInfo(props.row)"
                           icon-right="credit_card"
                           :label="props.row.cardNumber"/>
                  </q-card-section>
                  <q-card-section class="no-padding" v-if="!props.row.Cs_FamName">
                    {{
                      parseInt(props.row.transactionAmountDebit) > 0 ? props.row.optionalInformation1 : props.row.Cs_Name
                    }}
                  </q-card-section>
                </q-card>
              </td>
              <td class="text-green-10 text-weight-bolder">
                {{ parseInt(props.row.transactionAmountCredit).toLocaleString() }}
              </td>
              <td class="text-green-10 text-weight-bolder">
                {{ parseInt(props.row.transactionAmountDebit).toLocaleString() }}
              </td>
              <td class="text-bold">
                {{ props.row.fullDate | changeDateFormat }}
              </td>
            </q-tr>
            <q-tr :props="props" v-if="$q.screen.lt.md">
              <q-card class="q-ma-sm">
                <q-card-section class="no-padding">
                  <q-chip square color="red" text-color="white"
                          :label="props.row.Cs_Code"
                          v-if="props.row.Cs_Code"
                          @click="loadCustomer(props.row)"
                          clickable/>
                  <q-btn class="q-ma-sm"
                         v-if="!props.row.Cs_Code && props.row.transactionDescription !=='008'"
                         label="انتخاب مشتری" rounded color="indigo"
                         @click="selectedBestCustomer(props.row)"/>
                  <span class="text-bold">
                  {{ props.row.Cs_FirName }}
                  {{ props.row.Cs_FamName }}
                  </span>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-separator color="green"/>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-card flat>
                    <q-card-section class="no-padding">
                      <q-btn color="brown"
                             square
                             flat
                             :disable="parseInt(props.row.transactionAmountDebit) > 0"
                             @click="getAccountInfo(props.row)"
                             :label="props.row.cardNumber"/>
                      {{
                        parseInt(props.row.transactionAmountDebit) > 0 ? props.row.optionalInformation1 : props.row.Cs_Name
                      }}
                    </q-card-section>
                  </q-card>
                </q-card-section>
                <q-card-section class="no-padding">
                  <table>
                    <thead>
                    <tr class="text-center text-bold">
                      <td>واریز</td>
                      <td>برداشت</td>
                      <td>تاریخ تراکنش</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td class="text-green-10 text-weight-bolder">
                        {{ parseInt(props.row.transactionAmountCredit).toLocaleString() }}
                      </td>
                      <td class="text-green-10 text-weight-bolder">
                        {{ parseInt(props.row.transactionAmountDebit).toLocaleString() }}
                      </td>
                      <td class="text-bold">
                        {{ props.row.fullDate | changeDateFormat }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </q-card-section>
              </q-card>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
    <q-dialog v-model="customerInfoDialog">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>

    <q-dialog persistent v-model="transferDialog">
      <TransferMoney :account-balance="accountBalance" :selected-account="selectedAccount"/>
    </q-dialog>

    <q-dialog persistent v-model="emptyAccountDialog">
      <EmptyAccount :account-balance="accountBalance"
                    @decrease-account-balance="decreaseAccountBalance"
                    :selected-account="selectedAccount"/>
    </q-dialog>
    <q-dialog persistent v-model="selectCustomerDialog" v-if="selectedRow" full-width>
      <SelectCustomer :buy-list="false" :selected-customer="immediatelySaleCustomer"
                      :is-dialog="true"
                      :title="`انتخاب مشتری برای شماره کارت ${selectedRow.cardNumber}`"
                      @customerSelected="event=>immediatelyCustomerSelected(event)"/>
    </q-dialog>
  </q-pull-to-refresh>
</template>

<script>
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo.vue";
import SelectCustomer from "@/components/customers/SelectCustomer.vue";
import axios from "axios";
import TransferMoney from "@/components/Finnotech/TransferMoney.vue";
import EmptyAccount from "@/components/Finnotech/EmptyAccount.vue";

export default {
  name: "Transactions",
  components: {EmptyAccount, TransferMoney, SelectCustomer, CustomerInfo},
  props: {
    selectedAccountNumber: {
      type: String,
      default: () => undefined
    },
    isDialog: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      transactions: [],
      selectedCustomer: undefined,
      customerInfoDialog: false,
      emptyAccountDialog: false,
      immediatelySaleCustomer: undefined,
      selectedRow: undefined,
      accountNumber: "0101480222005",
      accountBalance: 0,
      accountNumbers: [
        {
          name: 'صندوق',
          accountNumber: '0101480222005',
          sourceFirstName: 'فاطمه',
          sourceLastName: 'نام خواه',
          merchantName: 'بازرگانی نوران',
          merchantIban: 'IR620620000000101480222005'
        },
        {
          name: 'کیف',
          accountNumber: '0303647823007',
          sourceFirstName: 'فاطمه',
          sourceLastName: 'نام خواه',
          merchantName: 'بازرگانی نوران',
          merchantIban: 'IR610620000000303647823007'
        }
      ],
      selectedAccount: undefined,
      transferDialog: false,
      selectCustomerDialog: false
    }
  },
  watch: {
    selectedAccount: function () {
      this.accountBalance = 0
      this.selectedRow = undefined
      this.loadData()
    }
  },
  methods: {
    ...mapActions({
      getTransactions: 'Finnotech/getTransactions',
      getCustomerInfo: 'Customers/get_customer_info_by_code',
      getCardInfo: 'Finnotech/getCardInfo',
      getBalance: 'Finnotech/getBalanceByAccountNumber',
      getIbanInfo: 'Finnotech/getIbanInfo',
      insertAccount: 'Customers/insertCustomerAccountNumber'
    }),
    loadbalance() {
      this.getBalance(this.selectedAccount.accountNumber).then((res) => {
        this.accountBalance = res.effectiveBalance
      })
    },
    decreaseAccountBalance(args) {
      this.accountBalance -= parseInt(args)
    },
    openEmptyAccountDialog() {
      this.emptyAccountDialog = true
    },
    openTransferDialog() {
      this.transferDialog = true
    },
    selectedBestCustomer(rowInfo) {
      this.selectedRow = rowInfo
      this.selectCustomerDialog = true
    },
    immediatelyCustomerSelected(args) {
      const foundIndex = this.transactions.findIndex(item => item.originKey === this.selectedRow.originKey)
      this.transactions[foundIndex].Cs_FirName = args.Cs_FirName
      this.transactions[foundIndex].Cs_FamName = args.Cs_FamName
      this.transactions[foundIndex].Cs_Code = args.Cs_Code
      this.transactions[foundIndex].Cs_ID = args.Cs_ID
      this.insertAccount({
        Id: args.Cs_ID,
        accountNumber: this.transactions[foundIndex].cardNumber
      }).then(() => {
        this.selectedRow = undefined
        this.selectCustomerDialog = false
      })
    },
    loadCustomer(rowInfo) {
      this.getCustomerInfo(rowInfo.Cs_Code).then((res) => {
        this.selectedCustomer = res.data[0]
        this.customerInfoDialog = true
      })
    },
    getAccountInfo(rowInfo) {
      if (rowInfo.transactionDescription === "008") return;
      if (rowInfo.Cs_Code) return;
      if (rowInfo.cardNumber.toString().substring(0, 2) === "IR") {
        this.getIbanInfo(rowInfo.cardNumber).then((res) => {
          rowInfo.Cs_Name = res.data.depositOwners[0].firstName + ' ' + res.data.depositOwners[0].lastName
        })
      } else {
        this.getCardInfo(rowInfo.cardNumber).then((res) => {
          rowInfo.Cs_Name = res.data.name
        })
      }
    },
    async loadData() {
      this.transactions = []
      await axios.all([
        this.getBalance(this.selectedAccount.accountNumber).then((res) => {
          this.accountBalance = res.effectiveBalance
        }),
      ])
    },
    async loadTransactionsData() {
      this.transactions = []
      await axios.all([
        this.getTransactions(this.selectedAccount.accountNumber).then((res) => {
          this.transactions = res.data
          this.transactions.filter(x => x.transactionClass === "IBAN").forEach(rec => {
            if (rec.additionalInformation && rec.additionalInformation.split('|').length >= 2) {
              if (rec.additionalInformation.split('|')[2].toString().startsWith('IR')) {
                rec.cardNumber = rec.additionalInformation.split('|')[2]
              }
            }
          })
        })
      ])
    },
    refresh(done) {
      this.loadData().then(() => done())
    }
  },
  created() {
    if (this.selectedAccountNumber) {
      this.selectedAccount = this.accountNumbers.filter(item => item.accountNumber === this.selectedAccountNumber)[0]
      this.loadTransactionsData()
    }
  }
}
</script>

<style scoped>

</style>